import { render, staticRenderFns } from "./EquipmentDataTable.vue?vue&type=template&id=5159d840&scoped=true&"
import script from "./EquipmentDataTable.vue?vue&type=script&lang=js&"
export * from "./EquipmentDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159d840",
  null
  
)

export default component.exports